const ValidateAction = ({ onClick }) => {
    return (
        <>
            <button
                className="bg-yellowgray text-white text-sm border rounded-lg p-3 px-4 py-2 capitalize"
                onClick={onClick}
            >
                Validate
        </button>
        </>
    )
}
export default ValidateAction